module.exports = __webpack_public_path__ + "static/media/lazy_macaque.78d41f31.jpg";